// The partner guide lives on its own site (guide-site/, guide.coepi.eu) and
// is opened from the portal menu. The dev portal links to the dev guide so a
// test partner account signs in where it exists.
export const partnerGuideUrl = (hostname: string = window.location.hostname): string =>
  hostname.startsWith('dev.') ? 'https://dev.guide.coepi.eu' : 'https://guide.coepi.eu';
